import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-6 pt-32 pb-20 overflow-hidden" data-id="element-49">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#333 1px, transparent 1px), linear-gradient(90deg, #333 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-50" />

      {/* Radial Gradient Overlay */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-transparent via-[#0a0a0a]/50 to-[#0a0a0a] pointer-events-none" data-id="element-51" />

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-53">
          <span className="inline-block py-1 px-3 rounded-full border border-[#333] bg-[#111] text-xs font-medium text-[#ff6b35] mb-6 tracking-wide uppercase" data-id="element-54">
            v2.0 is now live
          </span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.9] tracking-tight mb-8" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: 'easeOut'
      }} data-id="element-55">
          Mockups in seconds,
          <br data-id="element-56" />
          <span className="text-[#a3a3a3]" data-id="element-57">not hours.</span>
        </motion.h1>

        <motion.p className="text-lg md:text-xl text-[#a3a3a3] max-w-2xl mx-auto mb-10 leading-relaxed" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-58">
          Generate photorealistic device mockups from simple text descriptions.
          The premium design tool for teams who move fast.
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} data-id="element-59">
          <Button withArrow data-id="element-60">Start Creating</Button>
          <Button variant="ghost" data-id="element-61">See Examples</Button>
        </motion.div>
      </div>

      {/* Floating Mockup Preview */}
      <motion.div className="relative mt-20 w-full max-w-4xl mx-auto perspective-1000" initial={{
      opacity: 0,
      rotateX: 20,
      y: 100
    }} animate={{
      opacity: 1,
      rotateX: 0,
      y: 0
    }} transition={{
      duration: 1,
      delay: 0.5,
      ease: 'easeOut'
    }} data-id="element-62">
        <motion.div animate={{
        y: [0, -15, 0]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="relative z-10 bg-[#1a1a1a] border border-[#333] rounded-xl overflow-hidden shadow-2xl shadow-[#ff6b35]/10 aspect-video group" data-id="element-63">
          {/* UI Chrome */}
          <div className="h-10 bg-[#111] border-b border-[#333] flex items-center px-4 gap-2" data-id="element-64">
            <div className="w-3 h-3 rounded-full bg-[#ff5f57]" data-id="element-65" />
            <div className="w-3 h-3 rounded-full bg-[#febc2e]" data-id="element-66" />
            <div className="w-3 h-3 rounded-full bg-[#28c840]" data-id="element-67" />
            <div className="ml-4 h-5 w-64 bg-[#222] rounded-md" data-id="element-68" />
          </div>

          {/* Content Area */}
          <div className="p-8 flex items-center justify-center h-full bg-[#0f0f0f] relative overflow-hidden" data-id="element-69">
            <div className="absolute inset-0 bg-gradient-to-br from-[#ff6b35]/5 to-transparent" data-id="element-70" />

            {/* Abstract Shapes representing content */}
            <div className="grid grid-cols-2 gap-8 w-full max-w-2xl" data-id="element-71">
              <div className="space-y-4" data-id="element-72">
                <div className="h-32 bg-[#222] rounded-lg w-full animate-pulse" data-id="element-73" />
                <div className="h-4 bg-[#222] rounded w-3/4" data-id="element-74" />
                <div className="h-4 bg-[#222] rounded w-1/2" data-id="element-75" />
              </div>
              <div className="space-y-4 pt-12" data-id="element-76">
                <div className="h-32 bg-[#222] rounded-lg w-full animate-pulse delay-75" data-id="element-77" />
                <div className="h-4 bg-[#222] rounded w-3/4" data-id="element-78" />
                <div className="h-4 bg-[#222] rounded w-1/2" data-id="element-79" />
              </div>
            </div>

            {/* Floating Badge */}
            <motion.div className="absolute bottom-8 right-8 bg-[#ff6b35] text-white px-4 py-2 rounded-lg font-bold shadow-lg" initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 1.2,
            type: 'spring'
          }} data-id="element-80">
              Generated in 0.4s
            </motion.div>
          </div>
        </motion.div>

        {/* Glow Effect behind */}
        <div className="absolute -inset-4 bg-[#ff6b35] opacity-20 blur-3xl -z-10 rounded-full" data-id="element-81" />
      </motion.div>
    </section>;
}